import React, { useEffect, useState } from 'react'
import { BsWhatsapp } from 'react-icons/bs'

const WhatsAppLink = () => {
  const [show,setShow]=useState(false)
  useEffect(()=>{
    setTimeout(()=>{
      setShow(true)
    },5000)
  },[])
  return (
    <>
    {
      show && 
        <div className='fixed-link'>
            <a target="_blank" href="https://api.whatsapp.com/send?phone=917709362044&text=Hi, I need some help!"> 
                <BsWhatsapp />
            </a>
        </div>
    }
    </>
  )
}

export default WhatsAppLink